import React from 'react';
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  LayersControl
} from 'react-leaflet';
import * as L from 'leaflet';
import {MapHandlingProvider, useInspectionsMapContext} from '../../context';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import GeoLayer from "../GeoLayer";

const defaultPosition = {lat: 31.77785660652903, lng: 35.22211981700521};

const customIcon = L.icon({
  iconUrl: toAbsoluteUrl('/media/common/Home_primary.svg'),
  iconSize: [32, 32],
  iconAnchor: [12, 24],
  popupAnchor: [0, -18]
});

const MapContent = () => {
  const {points} = useInspectionsMapContext();

  return (
    <>
      {points.map((point, i) => (
        <Marker
          key={i}
          position={{lat: point.latitude, lng: point.longitude}}
          icon={customIcon}
        >
          <Popup>
            <div style={{fontSize: "24px", textAlign: "center"}}>{['מספר דוח', point.firmShumaID].filter(Boolean).join(': ')}</div>
            <div style={{fontSize: "24px", whiteSpace: "nowrap"}}>{[
              point.cityName, point.streetName, point.houseNumber
            ].filter(Boolean).join(' / ')}</div>
          </Popup>
        </Marker>
      ))}
    </>
  );
};

export const InspectionsMap = () => {

  return (
    <MapContainer
      center={defaultPosition}
      zoom={13}
      scrollWheelZoom={true}
      style={{
        height: 'calc(100vh - 175px)',
        width: '98.5%',
        margin: '0.5rem auto',
        display: 'block',
        zIndex: 9,
        borderRadius: '2rem',
        background: 'rgba(255, 255, 255, 0.18)',
        border: '1px solid rgba(255, 255, 255, 0.35)',
        boxShadow: '0 15px 40px rgba(0,0,0,0.25), inset 0 0 20px rgba(255,255,255,0.25)'
      }}
    >
      <MapHandlingProvider>
        <LayersControl position="topright">

          <LayersControl.BaseLayer checked name="OpenStreetMap">
            <TileLayer
              attribution='&copy; OpenStreetMap contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
          </LayersControl.BaseLayer>

          <LayersControl.Overlay name="גוש">
            <GeoLayer url="/mapLayers/getBlocksInsideBorders" color="#000"/>
            minZoom={10}
          </LayersControl.Overlay>

          <LayersControl.Overlay name="חלקה">
            <GeoLayer
              url="/mapLayers/getParcelsInsideBorders"
              color="rgb(0, 0, 128)"
              minZoom={16}
            />
          </LayersControl.Overlay>

        </LayersControl>
        <MapContent/>
      </MapHandlingProvider>
    </MapContainer>
  );
};